import { render, staticRenderFns } from "./wonderful.vue?vue&type=template&id=29d2a311&scoped=true&"
import script from "./wonderful.vue?vue&type=script&lang=js&"
export * from "./wonderful.vue?vue&type=script&lang=js&"
import style0 from "./wonderful.vue?vue&type=style&index=0&id=29d2a311&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d2a311",
  null
  
)

export default component.exports